<template>
  <div id="multibook-list">
    <div
      class="multibook-list-items"
      :style="bookColorTheme"
      :key="'multibook-list-item-' + index"
      v-for="(it, index) in multibooksArray"
      :class="{ 'multibook-list-item-disable': it.disable }"
      @click="goTo(it.name, it.router, it.disable)"
    >
      <div>
        <p :class="{ 'multibook-list-item-current': it.name == currentRoute }">
          <span v-if="multibookListIndexShow">{{ index + 1 }}.</span>{{ it.title }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'multibook-list',
  props: {
    multibooksArray: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data: function () {
    return {
      homePageData: null,
      multibooksListData: this.multibooksArray,
    };
  },

  methods: {
    redirectDev(type) {
      this.$router.push(`/${type}`);
    },

    goTo(id, router, disable) {
      if (id != this.currentRoute) {
        if (!disable && this.currentRoute != id) {
          if (router && router != 'main_book-view') {
            this.$store.commit('CHANGE_MULTIBOOK_TYPE', id);
            this.$router.push({ name: router });
          } else if (router === 'main_book-view') {
            this.$router.push({ name: router, params: { runBook: process.env.MAIN_BOOK_PATH } });
          } else {
            this.$emit('goTo', id);
          }
        }
      }
    },
  },
  computed: {
    currentRoute() {
      return this.$store.getters.multibookType;
    },
    multibookListIndexShow() {
      return this.$store.getters.multibookListIndexShow;
    },
    correctModuleName() {
      const name = `${this.$store.getters.multibookType
        .charAt(0)
        .toUpperCase()}${this.$store.getters.multibookType.slice(1)}`;

      return name;
    },
    bookColorTheme() {
      return { '--color': this.$store.getters[`${this.correctModuleName}/getBookColorTheme`] };
    },
  },
};
</script>

<style lang="sass">
@import '~@/assets/sass/variable';
$break-large: 1400px
#multibook-list
  z-index: 99999
  padding: 24px
  top: 84px
  left: 216px
  max-height: 63%
  background: white
  font-size: 1rem
  position: absolute
  border-radius: 10px 10px 0 0
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.1) inset
  .multibook-list-item-current
    font-weight: bold
    cursor: auto !important
    &:hover
      text-shadow: 0 0 9px transparent !important
  .multibook-list-items
    cursor: pointer
    &:hover
      text-shadow: 0 0 9px var(--color, $multiBookTitleColor)
    span
        text-align: left
        font-size: 1rem
        margin-letf: 24px
        margin-right: 24px
    p
        text-align: left
        font-size: 1rem
  .multibook-list-item-disable
    cursor: auto !important
    &:hover
      text-shadow: 0 0 9px transparent !important
</style>
